// extracted by mini-css-extract-plugin
module.exports = {"errorIcon":"errorIcon__cvf6r"};